import { BenefitType } from '../types';

const DEFAULT_HEADER = 'Claim your benefit';
const DEFAULT_SUBTITLE = '';
const DEFAULT_BUTTON_TEXT = 'Claim Benefit';
const DEFAULT_REQUESTED_BUTTON_TEXT = 'Requested!';

export const PERIOD_STRINGS = {
  'Every month': 'monthly',
  'Every three months': 'quarterly',
  'Every year': 'every year',
  'Every six months': 'every six months',
};

const formatAmount = (amount: string) => `$${Math.floor(parseFloat(amount))}`;

export const getCardContent = (
  carrier_name: string,
  benefit_type: BenefitType,
  benefit_info: any
): {
  title: string;
  subtitle: string;
  buttonText: string;
  requestedButtonText: string;
} => {
  switch (benefit_type) {
    case BenefitType.OTC: {
      const formattedMaxAmount = formatAmount(benefit_info.otc_benefit_max_amnt);
      const formattedPeriod = PERIOD_STRINGS[benefit_info.otc_benefit_max_per];
      return {
        title: `Claim your ${formattedMaxAmount} ${formattedPeriod} OTC credit at ${carrier_name}'s Pharmacy`,
        subtitle: 'Your plan offers credit towards over-the-counter pharmacy items.',
        buttonText: DEFAULT_BUTTON_TEXT,
        requestedButtonText: DEFAULT_REQUESTED_BUTTON_TEXT,
      };
    }
    case BenefitType.DENTAL:
      return {
        title: 'Schedule your covered dental cleaning',
        subtitle: `Your plan includes ${benefit_info.cleanings_count} cleanings
          ${
            PERIOD_STRINGS[benefit_info.cleanings_per]
          }. We can schedule it for you using your current dentist, or help you find a new dentist.`,
        buttonText: 'Schedule',
        requestedButtonText: DEFAULT_REQUESTED_BUTTON_TEXT,
      };

    case BenefitType.FITNESS:
      return {
        title: 'Sign up for your covered gym membership',
        subtitle: 'Your plan provides a covered gym membership. We can help you sign up for it!',
        buttonText: 'Sign up',
        requestedButtonText: DEFAULT_REQUESTED_BUTTON_TEXT,
      };

    case BenefitType.VISION:
      return {
        title: 'Claim your frames & lenses benefit',
        subtitle: `Your plan allows you to order ${benefit_info.lenses_frames_count} pairs of lenses / frames ${
          PERIOD_STRINGS[benefit_info.lenses_frames_period]
        }.`,
        buttonText: DEFAULT_BUTTON_TEXT,
        requestedButtonText: DEFAULT_REQUESTED_BUTTON_TEXT,
      };

    default:
      return {
        title: DEFAULT_HEADER,
        subtitle: DEFAULT_SUBTITLE,
        buttonText: DEFAULT_BUTTON_TEXT,
        requestedButtonText: DEFAULT_REQUESTED_BUTTON_TEXT,
      };
  }
};
